import React from 'react';
import ReactDOM from 'react-dom';

// react router
import AppRouter from './routers/router';

// react es5 babel兼容性
import 'babel-polyfill';
import 'es5-shim';
import 'es5-shim/es5-sham';
import 'console-polyfill';

// scss
import 'normalize.css';
import './index.scss';
import './assets/css/index.scss';

// server
import * as serviceWorker from './serviceWorker';

// 设置环境变量和appId
window.formGlobalData = {
  env: process.env.NODE_ENV,
  appId: process.env.NODE_ENV === 'development' ? 'wxe3690091973265fb' : 'wx12624cb46d85b681'
  // appId: 'wxe3690091973265fb' 
};

ReactDOM.render(<AppRouter />, document.getElementById('root'));

// 百度统计
var _hmt = _hmt || [];
(function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?b7f9f741f8bc512246e73628added57e";
    var s = document.getElementsByTagName("script")[0]; 
    s.parentNode.insertBefore(hm, s);
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
